var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    [
      _c(
        "q-list",
        { attrs: { link: "" } },
        [
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              staticClass: "item item-link",
              nativeOn: {
                click: function($event) {
                  return _vm.handleExportCustomer($event)
                }
              }
            },
            [
              _c(
                "q-item-side",
                [_c("q-icon", { attrs: { name: "cloud_download" } })],
                1
              ),
              _c("q-item-main", [
                _c("span", [_vm._v(_vm._s(this.exportButtonText))])
              ])
            ],
            1
          ),
          _c("q-item-separator"),
          _vm.singleCustomer
            ? _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" },
                    { name: "is-user", rawName: "v-is-user" }
                  ],
                  staticClass: "item item-link",
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleEditCustomer($event)
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [_c("q-icon", { attrs: { name: "edit" } })],
                    1
                  ),
                  _c("q-item-main", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("edit")))])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.customers.length
            ? _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" },
                    { name: "is-user", rawName: "v-is-user" }
                  ],
                  staticClass: "item item-link",
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleDeleteCustomer($event)
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [_c("q-icon", { attrs: { name: "delete" } })],
                    1
                  ),
                  _c("q-item-main", [
                    _c("span", [_vm._v(_vm._s(_vm.$t("remove")))])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }